
import React, { useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';


const ErrorMessage = props => {
    
    const {
        errorMessage,
        header = null,
        id,
        closeRef,
        errorMessageReplacements,
        extraAction = null,
        parentAction: {
            closeError
        } = {},
        isCrossButtonHidden = false,
        additionalContent = null
    } = props;

    const warningRef = useRef(null);
    const ref = closeRef ? closeRef : warningRef;

    useEffect(() => {
        if(ref.current) {
            ref.current.scrollIntoView({ behavior: 'smooth' });
            ref.current.focus();
        }
    }, [ errorMessage, errorMessageReplacements ]);

    const handleCloseClick = e => {
        e.preventDefault();
        closeError(null);
    };
    
    return (
        <div
            className="usa-alert usa-alert--error position-relative"
            id="focused_one"
        >
            <div className="usa-alert__body">
                {
                    header &&

                    <h4 className = "text-left">
                        <FormattedMessage
                            id = {header}
                        />
                    </h4>
                }
                <p className="usa-alert__text" data-automation-id={`txt_error_handling${id}`}>
                    <FormattedMessage
                        id = {errorMessage}
                        values = {errorMessageReplacements}
                    />    
                </p>
                { additionalContent }
                { extraAction }
            </div>
            {
                !isCrossButtonHidden &&

                <div className="gi-modal__btn--close position-absolute right-05 top-05">
                    <a
                        id = 'close-button-icon'
                        href = "#"
                        onClick = {handleCloseClick}
                        ref = { ref }
                        aria-label="Close"
                        data-automation-id='link_error_handling_close'
                    >
                        <FontAwesomeIcon icon="times"/>
                    </a>
                </div>
            }
        </div>
    );
};

export default ErrorMessage;
